import { uploadImage } from "../apis/apiHandler";

export const uploadFileToS3 = async (file, folderName) => {
  try {
    const fileExtension = file.name.split(".").pop();
    const cleanFileName = file.name.replace(/\s+/g, "_"); // optional cleanup

    const s3Response = await uploadImage({
      image_folders: [
        {
          bucket_folder_name: folderName,
          file_name: cleanFileName,     // ✅ send filename
          file_type: fileExtension,
        },
      ],
    });

    const { upload_url, file_name } = s3Response?.data?.[0] || {};

    if (!upload_url || !file_name) {
      throw new Error("Failed to get signed URL");
    }

    const uploadResponse = await fetch(upload_url, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": file.type,
      },
    });

    if (!uploadResponse.ok) {
      throw new Error("S3 upload failed");
    }

    return {
      fileName: file_name, // ✅ store in DB
      fileType: file.type,
    };
  } catch (err) {
    console.error("uploadFileToS3 error:", err);
    throw err;
  }
};
